import { Flex } from '@chakra-ui/react'
import { useState, useCallback } from 'react'
import { TravelHistoryTable } from './components/TravelHistoryTable'
import { InfoSection } from './components/InfoSection'

function Home() {
  const [showHistory, setShowHistory] = useState(false)

  // InfoSection will call this once loading is finished.
  const handleInfoDone = useCallback(() => {
    setShowHistory(true)
  }, [])

  return (
    <Flex direction='column' gap='20px' flex='1'>
      <InfoSection onEnterComplete={handleInfoDone} />
      {showHistory && <TravelHistoryTable home />}
    </Flex>
  )
}

export default Home